<div class="md:flex md:items-center md:justify-between">
	<div class="min-w-0 flex-1">
		<h1 class="">Finanzen</h1>
	</div>
  <div class="mt-4 flex md:ml-4 md:mt-0 gap-2">
    <button (click)="openInvoiceList(0)" type="button" class="secondary">Alle Rechnungen</button>
  </div>
</div>
<div *ngIf="loading" class="py-4">
  <div role="status">
    <svg aria-hidden="true" class="inline w-9 h-9 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#333333"/>
    </svg>
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div *ngIf="!loading">
  <!-- meta data -->
  <dl class="mx-auto grid grid-cols-1 gap-px border border-sand sm:grid-cols-2 lg:grid-cols-3 my-8">
    <div class="border-b sm:border-r lg:border-b-0 border-grey-light gap-x-4 gap-y-2 bg-white px-4 py-10 sm:px-6 xl:px-8">
      <dt class="text-sand">Offene Rechnungen</dt>
      <dd class="w-full flex-none tracking-tight mt-1">
        <h3>{{ totals.numb_open }}</h3>
      </dd>
    </div>
    <div class="border-b lg:border-r lg:border-b-0 border-grey-light gap-x-4 gap-y-2 bg-white px-4 py-10 sm:px-6 xl:px-8">
      <dt class="text-sand">Offene Rechnungen</dt>
      <dd class="w-full flex-none tracking-tight mt-1">
        <h3>{{ (totals.sum_open | number:"1.2-2":"de-DE") + " €" }}</h3>
      </dd>
    </div>
    <div class="border-b sm:border-r sm:border-b-0 border-grey-light gap-x-4 gap-y-2 bg-white px-4 py-10 sm:px-6 xl:px-8">
      <dt class="text-sand">Umsatz dieses Jahr</dt>
      <dd class="w-full flex-none tracking-tight mt-1">
        <h3>{{ (totals.sum_paid | number:"1.2-2":"de-DE") + " €" }}</h3>
      </dd> 
    </div>
  </dl>
  <ul role="list" class="mt-8 grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-2 xl:gap-x-8">
    <!-- open invoices box -->
    <li class="overflow-hidden border border-sand">
      <div class="flex justify-between items-center gap-x-4 bg-grey-light border-b border-sand p-4">
        <div class="flex items-baseline gap-4">
          <span class="text-txt-large">Offene Rechnungen</span>
        </div>
      </div>
      <dl class="p-4">
        <div *ngFor="let invoice of filterInvoices(1).slice(0,2)" class="flex items-center justify-between border-b border-1 pb-4 mb-4">
          <div>
            <div class="flex items-center gap-4">
              <h3>{{ invoice.acf.content.invoice_counter }}</h3>
              <p [attr.data-value]="invoice.acf.status" class="document_status">
                <span *ngIf="invoice.acf.status == 1">• Erstellt</span>
                <span *ngIf="invoice.acf.status == 2">• Bezahlt</span>
                <span *ngIf="invoice.acf.status == 3">• Storniert</span>
              </p>
            </div>
            <p class="text-sand text-txt-small">{{ (invoice.acf.timestamp | date:"dd.MM.YYYY") }} - {{ invoice.acf.content.recipient.acf.firstname }} {{ invoice.acf.content.recipient.acf.lastname }}</p>
          </div>
          <div class="flex items-center gap-2">
            <button [routerLink]="['/dashboard/document/' + invoice.id]" type="button" class="secondary">Bearbeiten</button>
          </div>
        </div>
        <div *ngIf="totals.numb_open != 0" class="flex items-center justify-between gap-8">
          <div>
            <p class="font-bold">Offener Betrag</p>
            <p>{{ (totals.sum_open | number:"1.2-2":"de-DE") + " €" }}</p>
          </div>
          <button (click)="openInvoiceList(1)" type="button" class="secondary">Liste anzeigen</button>
        </div>
        <p *ngIf="totals.numb_open == 0">Aktuell gibt es keine offenen Rechnungen!</p>
      </dl>
    </li>
    <!-- paid invoices box -->
    <li class="overflow-hidden border border-sand">
      <div class="flex justify-between items-center gap-x-4 bg-grey-light border-b border-sand p-4">
        <div class="flex items-baseline gap-4">
          <span class="text-txt-large">Bezahlte Rechnungen</span>
        </div>
      </div>
      <dl class="p-4">
        <div *ngFor="let invoice of filterInvoices(2).slice(0,2)" class="flex items-center justify-between border-b border-1 pb-4 mb-4">
          <div>
            <div class="flex items-center gap-4">
              <h3>{{ invoice.acf.content.invoice_counter }}</h3>
              <p [attr.data-value]="invoice.acf.status" class="document_status">
                <span *ngIf="invoice.acf.status == 1">• Erstellt</span>
                <span *ngIf="invoice.acf.status == 2">• Bezahlt</span>
                <span *ngIf="invoice.acf.status == 3">• Storniert</span>
              </p>
            </div>
            <p class="text-sand text-txt-small">{{ (invoice.acf.timestamp | date:"dd.MM.YYYY") }} - {{ invoice.acf.content.recipient.acf.firstname }} {{ invoice.acf.content.recipient.acf.lastname }}</p>
          </div>
          <div class="flex items-center gap-2">
            <button [routerLink]="['/dashboard/document/' + invoice.id]" type="button" class="secondary">Bearbeiten</button>
          </div>
        </div>
        <div *ngIf="totals.numb_paid != 0" class="flex items-center justify-between gap-8">
          <div>
            <p class="font-bold">Bezahlter Betrag</p>
            <p>{{ (totals.sum_paid | number:"1.2-2":"de-DE") + " €" }}</p>
          </div>
          <button (click)="openInvoiceList(2)" type="button" class="secondary">Liste anzeigen</button>
        </div>
        <p *ngIf="totals.numb_paid == 0">Aktuell gibt es keine bezahlten Rechnungen!</p>
      </dl>
    </li>
  </ul>
</div>
<div *ngIf="invoices_slide_over" class="relative z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
        <div class="pointer-events-auto w-screen max-w-5xl">
          <div class="flex h-full flex-col overflow-y-scroll bg-white p-6 shadow-xl">
            <div>
              <div class="flex justify-end mb-2">
                <a (click)="invoices_slide_over = false" type="button" class="cursor-pointer">
                  <span class="sr-only">Schließen</span>
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 22.5L22.5 7.5M7.5 7.5L22.5 22.5" stroke="#505050" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div>
              <div class="flex items-start justify-between mb-4">
                <h2 id="slide-over-title">Rechnungen</h2>
              </div>
            </div>
            <div>
              <div class="mt-4">
                <p class="pb-2">Filter</p>
                <select [(ngModel)]="invoice_filter" (change)="changeInvoiceListFilter($event)">
                  <option value="0">Alle Rechnungen</option>
                  <option value="1">Erstellt</option>
                  <option value="2">Bezahlt</option>
                  <option value="3">Storniert</option>
                </select>
              </div>
              <div class="mt-8">
                <ng-container *ngFor="let invoice of invoices">
                  <div *ngIf="invoice.acf.status == invoice_filter || invoice_filter == 0" class="flex items-center justify-between border-b border-1 pb-4 mb-4">
                    <div>
                      <div class="flex items-center gap-4">
                        <h3>{{ invoice.acf.content.invoice_counter }}</h3>
                        <p [attr.data-value]="invoice.acf.status" class="document_status">
                          <span *ngIf="invoice.acf.status == 1">• Erstellt</span>
                          <span *ngIf="invoice.acf.status == 2">• Bezahlt</span>
                          <span *ngIf="invoice.acf.status == 3">• Storniert</span>
                        </p>
                      </div>
                      <p class="text-sand text-txt-small">{{ (invoice.acf.timestamp | date:"dd.MM.YYYY") }} - {{ invoice.acf.content.recipient.acf.firstname }} {{ invoice.acf.content.recipient.acf.lastname }}</p>
                    </div>
                    <div class="flex items-center gap-2">
                      <button [routerLink]="['/dashboard/document/' + invoice.id]" type="button" class="secondary">Bearbeiten</button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>